"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styles_1 = require("@material-ui/core/styles");
var drawerWidth = 240;
var useStyles = (0, styles_1.makeStyles)(function (theme) {
    var _a;
    return (0, styles_1.createStyles)({
        root: {
            display: 'flex',
        },
        toolbar: theme.mixins.toolbar,
        drawerPaper: {
            width: drawerWidth,
        },
        content: (_a = {
                flexGrow: 1,
                padding: theme.spacing(2)
            },
            _a[theme.breakpoints.up('md')] = {
                marginLeft: drawerWidth,
            },
            _a),
    });
});
function Container(props) {
    var classes = useStyles({});
    return (React.createElement("main", { className: classes.content },
        React.createElement("div", { className: classes.toolbar }),
        props.children));
}
exports.default = Container;
//# sourceMappingURL=Container.js.map